import { getIsSignerReadyToSign } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/components/SignerGroupSection.utils';
import {
	DocumentSigningScope,
	InvestmentProgrammeDocumentDetailsRes,
	SignatureType,
} from '@dealstack/shared/lib/generated';

type SignerGroup = InvestmentProgrammeDocumentDetailsRes['groups'][number];

export const findClaimedGroupReadyToSign = ({
	pendingClaimSignRoleId,
	isSignerUpdatePending,
	groups,
	currentUserId,
	documentSignatureType,
	documentSigningScope,
	isEidEasyDocument,
}: {
	pendingClaimSignRoleId: string | null;
	isSignerUpdatePending: boolean;
	groups: SignerGroup[];
	currentUserId: string | undefined;
	documentSignatureType?: SignatureType | null;
	documentSigningScope?: DocumentSigningScope | null;
	isEidEasyDocument?: boolean;
}): SignerGroup | null => {
	if (!pendingClaimSignRoleId || !currentUserId || isSignerUpdatePending) {
		return null;
	}

	// Electronic documents not configured for eID Easy have no signing route, so
	// there is nothing for the post-claim effect to start.
	if (documentSignatureType === SignatureType.ELECTRONIC && !isEidEasyDocument) {
		return null;
	}

	const group = groups.find((g) => g.roleId === pendingClaimSignRoleId);
	if (!group) {
		return null;
	}

	const signer = group.signers.find((s) => s.assigned && s.userId === currentUserId);
	if (!signer) {
		return null;
	}

	const ready = getIsSignerReadyToSign({
		documentSignatureType,
		documentSigningScope,
		signer,
		isSignerUpdatePending,
		isEidEasyDocument,
	});

	return ready ? group : null;
};
